import axios from "axios";


const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

console.log("📡 Frontend points to API at:", API_URL);

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true, // Crucial for cookies
});

// Request Interceptor: Attach Token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response Interceptor for Global Errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear storage and redirect on unauthorized
      localStorage.removeItem("user");
      // Optional: window.location.href = "/login";
    }

    // Default error alert if not handled by component
    /*
    Swal.fire({
      icon: 'error',
      title: 'API Error',
      text: error.response?.data?.message || "Something went wrong",
      background: '#0b0b0b',
      color: '#fff'
    });
    */

    return Promise.reject(error);
  }
);

export default api;
